import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { appConfig } from '../../config/appConfig';
import { DEMO_SESSION_KEY } from '../../config/demoConfig';
import './DemoDashboard.css';

const modules = [
  { icon: 'fa-users', title: 'Clientes', value: '0', description: 'Colección independiente' },
  { icon: 'fa-calendar-check', title: 'Reservas', value: '0', description: 'Sin reservas registradas' },
  { icon: 'fa-route', title: 'Viajes', value: '0', description: 'Historial de Levapán' },
  { icon: 'fa-file-excel', title: 'Reportes', value: '0', description: 'Listos para exportar' }
];

function DemoDashboard() {
  const navigate = useNavigate();
  const hasDemoSession = sessionStorage.getItem(DEMO_SESSION_KEY) === 'active';

  if (!hasDemoSession) {
    return <Navigate to="/login" replace />;
  }

  const logout = () => {
    sessionStorage.removeItem(DEMO_SESSION_KEY);
    navigate('/login');
  };

  return (
    <div className="demo-dashboard">
      <header className="demo-header">
        <div className="demo-logo">
          <span className="demo-logo-mark">L</span>
          <div>
            <strong>{appConfig.companyName}</strong>
            <small>Gestión de transporte</small>
          </div>
        </div>
        <div className="demo-user">
          <span className="demo-pill">Modo demostración</span>
          <button type="button" onClick={logout}>Cerrar sesión</button>
        </div>
      </header>

      <main className="demo-main">
        <section className="demo-welcome">
          <div>
            <p>Panel administrativo</p>
            <h1>Bienvenido a {appConfig.appName}</h1>
            <span>Este entorno local no contiene datos reales ni está conectado con Big Security.</span>
          </div>
          <div className="demo-status"><i className="fas fa-shield-alt"></i> Datos aislados</div>
        </section>

        <section className="demo-grid" aria-label="Resumen del sistema">
          {modules.map(module => (
            <article className="demo-module" key={module.title}>
              <div className="demo-module-icon"><i className={`fas ${module.icon}`}></i></div>
              <div>
                <span>{module.title}</span>
                <strong>{module.value}</strong>
                <small>{module.description}</small>
              </div>
            </article>
          ))}
        </section>

        <section className="demo-setup">
          <div className="demo-setup-icon"><i className="fas fa-database"></i></div>
          <div>
            <h2>Conecta Firebase para activar el sistema</h2>
            <p>Al agregar las credenciales de Levapán se habilitarán clientes, reservas, historial, reportes y usuarios reales.</p>
          </div>
          <span>Configuración pendiente</span>
        </section>
      </main>
    </div>
  );
}

export default DemoDashboard;
